import * as React from 'react'
import {
  Box,
  Button,
  Heading,
  Stack,
  Text,
  Flex,
  Badge,
  useColorModeValue as mode,
  Img,
} from '@chakra-ui/react'
import { FaArrowRight } from 'react-icons/fa'

export const CourseHero = ({
  level,
  duration,
  instructor,
  instructorImg,
  courseName,
  marginTop,
  dates,
  desc,
  enroll,
  ...props
}) => {
  return (
    <Box as="section" bg={{ base: 'blue.100', lg: 'gray.50' }} pt={{ base: '5', lg: '6' }} marginTop={marginTop} >
      <a id="program" />
      <Box maxW={{ base: '3xl', md: '7xl' }} mx="auto" px={{ base: '0', lg: '8' }}>
        <Stack spacing={{ base: '0', lg: '10' }} direction={{ base: 'column', lg: 'row' }} alignItems="center">
          <Box position="relative" width={{ base: 'xs', sm:'sm', xl: 'lg' }} minW="310px" pt="0px">
            <Img
              src={instructorImg}
              alt={instructor}
              width={{ base: '200', md: '300' }}
              height={{ base: '337', md: '506' }}
              layout="intrinsic"
            />
            <Flex position="absolute" ml={{ base: '175', md: '230' }} top="80px" minW="200px">
              <Badge boxSize="1em" borderRadius="full" bg="green.500" position="absolute" top="14px" />
              <Box ml="5">
                <Text fontWeight="bold" h="12px" fontSize="sm">{instructor}</Text>
                <Text fontSize="sm" color="blue.500">Lead Teacher</Text>
              </Box>
            </Flex>
          </Box>
          <Box bg="gray.50">
            <Box maxW={{ base:'100%', lg: '2xl', xl: '3xl' }} pt={{ base: '8', lg: '0' }} px={{ base: '6', md: '10', lg: '8' }} pb={{ base: '8', lg: '0' }}>
              {level &&
                <Box d="flex" alignItems="baseline" mb="1em">
                  <Badge borderRadius="2px" px="2" colorScheme="blue">
                    {level}
                  </Badge>
                  <Box
                    color="gray.500"
                    fontWeight="semibold"
                    letterSpacing="wide"
                    fontSize="xs"
                    textTransform="uppercase"
                    ml="2"
                  >
                    {duration}
                  </Box>
                </Box>
              }
              <Heading
                as="h2"
                size="2xl"
                fontFamily="Tomato Grotesk"
                color={mode('gray.900', 'gray.900')}
                whiteSpace="pre-line"
              >
                {courseName}
              </Heading>
              <Text pt="2" fontWeight="bold" color="gray.900">
                Next training: {dates}
              </Text>
              <Text
                as="div"
                fontSize={{ base: 'md', lg: 'lg' }}
                mt="3"
                color={mode('gray.900', 'gray.900')}
                whiteSpace="pre-line"
              >
                {desc}
              </Text>
              <Button
                className="group"
                mt="2"
                colorScheme="blue"
                size="md"
                pl="1.2em"
                pr="1em"
                fontWeight="bold"
                h="12"
                as="a"
                href={enroll}
                target="_blank"
                rightIcon={<FaArrowRight />}
              >
                Learn more
              </Button>
            </Box>
          </Box>
        </Stack>
      </Box>
    </Box>
  )
}